<template>
  <div
    class="bg-gradient-to-r from-gray-100 via-gray-300 to-white sm:pb-4 sm:pt-4 sm:mb-8"
  >
    <div class="max-w-5xl mx-auto">
      <dl
        class="rounded-lg bg-white shadow-lg sm:flex justify-center align-center|"
      >
        <div
          v-for="snap in snaps"
          :key="snap.id"
          class="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r"
        >
          <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500">
            {{ snap.name }}
          </dt>
          <dd class="order-1 text-5xl font-extrabold text-indigo-600">
            {{ snap.number }}
          </dd>
        </div>
        <div
          class="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l"
        >
          <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500">
            Homes for Sale
          </dt>
          <dd class="order-1 text-5xl font-extrabold text-indigo-600">
            {{ count }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
export default {
  props: ["count"],
  data() {
    return {
      snaps: []
    };
  },

  created() {
    this.getSnapshots();
  },

  methods: {
    getSnapshots() {
      window.axios.get("/api/getStats").then(res => {
        this.snaps = res.data;
        // this.count = res.data[1];
      });
    }
  }
};
</script>
